export default __webpack_public_path__ + "static/media/img-0125-france-half-face.6e081ba2.png";